import React, { useState } from "react";
import {
  COACHING_DOMAIN,
  CoachingFaq,
  coachingFaqApi,
  FAQ_LIST_ENDPOINT,
} from "api/coachingFaqApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CustomModal from "../../common/CustomModal";
import Link from "../../common/Link";

interface DeleteCoachingFaqButtonProps {
  faq: CoachingFaq;
}

export default function DeleteCoachingFaqButton({
  faq,
}: DeleteCoachingFaqButtonProps) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const deleteMutation = useMutation({
    mutationFn: () => coachingFaqApi.delete(faq.faqId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [COACHING_DOMAIN, FAQ_LIST_ENDPOINT],
      });
    },
  });

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <Link text="삭제" opacity={1} textColor="primary.solid" />
      </div>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title={"이 FAQ를 삭제할까요?"}
        subtitle={`${faq.question}`}
        actions={[
          {
            label: "삭제하기",
            variant: "Solid",
            color: "danger",
            onClick: () => {
              deleteMutation.mutate();
              setOpen(false);
            },
          },
          {
            label: "취소",
            variant: "Plain",
            onClick: () => setOpen(false),
          },
        ]}
      />
    </>
  );
}